import { render, staticRenderFns } from "./DSHeader.vue?vue&type=template&id=3c707678&scoped=true&"
import script from "./DSHeader.vue?vue&type=script&lang=ts&"
export * from "./DSHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DSHeader.vue?vue&type=style&index=0&id=3c707678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c707678",
  null
  
)

export default component.exports